var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5996 3C12.9251 3 14 4.07491 14 5.40039V10.0498C14 11.3753 12.9251 12.4502 11.5996 12.4502H5.02832C4.61648 12.4503 4.21154 12.556 3.85254 12.7578L2.71484 13.3975C2.39499 13.5771 2.00016 13.3464 2 12.9795V5.40039C2 4.07491 3.07491 3 4.40039 3H11.5996ZM5 8.40039C4.66863 8.40039 4.40039 8.66863 4.40039 9C4.40039 9.33137 4.66863 9.59961 5 9.59961H11C11.3314 9.59961 11.5996 9.33137 11.5996 9C11.5996 8.66863 11.3314 8.40039 11 8.40039H5ZM5 6C4.66876 6 4.4006 6.26842 4.40039 6.59961C4.40039 6.93098 4.66863 7.19922 5 7.19922H11C11.3314 7.19922 11.5996 6.93098 11.5996 6.59961C11.5994 6.26842 11.3312 6 11 6H5Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.ca65ed5877b84c24d21213d364b4337d.svg";
export { ForwardRef as ReactComponent };